import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M26.4201 1.60999C41.5801 1.60999 47.5501 11.19 49.8001 22.15C52.0501 33.11 49.6001 42.5 49.6001 42.5C49.6001 42.5 46.7601 35.46 46.5701 24.21C46.4301 15.9 44.0301 10.81 40.9001 8.35999C37.7701 5.90999 32.8801 5.28003 32.8801 5.28003L26.1001 11.79L19.5501 5.28003C19.5501 5.28003 14.6601 5.91999 11.5301 8.35999C8.4001 10.81 6.0001 15.89 5.8601 24.21C5.6601 35.46 2.8301 42.5 2.8301 42.5C2.8301 42.5 0.380102 33.11 2.6301 22.15C4.8801 11.19 10.8501 1.60999 26.0101 1.60999H26.4201Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
